export const Footer = () => (
    <footer className="bg-ink2 text-[#9C9994] py-10 px-6 text-center text-[0.82rem]" data-testid="footer">
        <img src="/logo-ah.png" alt="Logo Adriana Hernández" className="h-8 w-auto mx-auto mb-4" data-testid="footer-logo" />
        <span className="font-serif italic text-roselight">Adriana Hernández</span> · Personal Trainer ·{' '}
        <a
            href="https://www.instagram.com/adrihernanndez"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="hover:text-paper transition-colors"
        >
            @adrihernanndez
        </a>{' '}
        · © 2026
    </footer>
);
